module.exports = __webpack_public_path__ + "static/media/B8_1.PNG.5b5bc196.png";